import store from "@/store";
import { httpClient } from "./http-client";
import { TERRA_API_HOST } from "../api-hosts";
export default class FeatureService {
    async getAll(req){
        return httpClient({
            url: `features/${store.state.route_name}/${store.state.container.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
        })
    }
    async get(req){
        return httpClient({
            url: `features/${req.uid}/${store.state.route_name}/${store.state.container.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers
        })
    }
    async delete(req){
        return httpClient({
            url: `features/${req.uid}/${store.state.route_name}/${store.state.container.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
            method: 'delete'
        })
    }
    async put(req){
        return httpClient({
            url: `features/${req.uid}/${store.state.route_name}/${store.state.container.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
            method: 'put',
            data: req.body
        })
    }
    async patch(req){
        return httpClient({
            url: `features/${req.uid}/${store.state.route_name}/${store.state.container.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
            method: 'patch',
            data: req.body
        })
    }
    async post(req){
        return httpClient({
            url: `features/${store.state.route_name}/${store.state.container.uid}/project/${req.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
            method: 'post',
            data: req.body
        })
    }
    async get_project_features(req){
        return httpClient({
            url: `features/${store.state.route_name}/${store.state.container.uid}/project/${req.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
        })
    }
    async get_master_uid_data(req){
        return httpClient({
            url: `features/${req.uid}/${store.state.route_name}/${store.state.container.uid}/master/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
        })
    }
}
